module.exports = {
  title: 'Что-то пошло не так',
  link: {
    main: 'Вернуться на главную',
  },
};
